import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import * as SVG from '~/assets/svg'
import { Header } from '~/components/header'
import { Sidebar } from '~/components/sidebar'
import * as route from '~/helper/constant/route'
import { AbstractExpenseComponent, mapStateToProps } from './abstract'

class ExpenseComponent extends AbstractExpenseComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
    }

    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Sidebar id="expense" isAccount={true} />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.accounting.menu}>{t('sidebar:account')} &nbsp; &gt; &nbsp;</a>
                            </li>
                            <li>{t('accounting:expense')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <h5 className="main-title heading5">{t('accounting:expense')}:</h5>
                            </div>
                        </div>
                    </div>
                    <div className="folder-page">
                        <div className="row clearfix">
                            <div className="float-left course-your">
                                <div
                                    className="folder-list clearfix"
                                    onClick={() => (window.location = route.admin.accounting.expense.bill.view)}
                                >
                                    <a href={route.admin.accounting.expense.bill.view} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.expense.bill.view} className="folder-name">
                                        {t('accounting:bill')}
                                        <span> {t('income:managebill')}</span>
                                    </a>
                                </div>
                            </div>

                            <div className="float-left course-your">
                                <div
                                    className="folder-list clearfix"
                                    onClick={() => (window.location = route.admin.accounting.expense.template.view)}
                                >
                                    <a href={route.admin.accounting.expense.template.view} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.expense.template.view} className="folder-name">
                                        {t('expense:bill')} {t('income:template')}
                                        <span>
                                            {t('expense:createbill')} {t('income:template')}
                                        </span>
                                    </a>
                                </div>
                            </div>

                            <div className="float-left course-your">
                                <div
                                    className="folder-list clearfix"
                                    onClick={() => (window.location = route.admin.accounting.expense.billsummary)}
                                >
                                    <a href={route.admin.accounting.expense.billsummary} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.expense.billsummary} className="folder-name">
                                        {t('reports:billsummary')}
                                        <span> {t('reports:viewbillsummary')}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const Expense = withTranslation()(connect(mapStateToProps)(ExpenseComponent))

export { Expense }
